module.exports = __webpack_public_path__ + "static/media/carroussel_02.02c40d7d.jpg";